// 数字の表記に関するUtilsまとめ

/**
 * 3桁区切りで数字を出力する(引数が空の時はnullを返却する)
 * @param numStr 数字の文字列
 */
const splitNumberFormat = (numStr?: string | number | null): string | null => {
  let num = -1;
  if (!numStr) return null;
  num = Number(numStr);
  if (isNaN(num)) return numStr.toString();
  return new Intl.NumberFormat().format(num);
};

export { splitNumberFormat };
